// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"d6feb547","228":"fe5c8648","294":"0e925ca1","358":"5d64d116","379":"6832a497","401":"742d873c","453":"841296c2","524":"c026f0b1","696":"5af62962","744":"c0dfe311","790":"04fb2e4b","871":"f09cf22e","929":"c1287e99","945":"c1ab3c54"}[chunkId] + ".chunk.js";
};